<div class="project-details-page page">
    <main class="project-details-page__content content">

        <header>
            <div class="page-title">Project Details</div>
            <div class="page-subtitle">Manage your project</div>
        </header>

        <section class="project-details-page__section-content">
            <div class="flex-horizontal dds-mb-5">
                <div class="project-details-page__section-heading">
                    <div class="project-details-page__section-title">{{project?.name}}</div>

                    <div class="dds-label greyed-out">
                        Created: {{project?.createdAt | date :'mediumDate'}} <br />
                        Last updated: {{project?.updatedAt | date :'mediumDate'}}
                    </div>

                    <div>{{project?.description}}</div>
                </div>
                <div>
                    <dds-button [theme]=" editButtonOptions.theme" [kind]="editButtonOptions.kind"
                        [size]="editButtonOptions.size" [width]="editButtonOptions.width"
                        [icon]="editButtonOptions.icon" [isIconLeft]="editButtonOptions.isIconLeft"
                        [role]="editButtonOptions.role" [isInverse]="editButtonOptions.isInverse"
                        [isColorBg]="editButtonOptions.isColorBg" [isLoading]="editButtonOptions.isLoading"
                        [ariaLabel]="editButtonOptions.ariaLabel" [customClass]="editButtonOptions.customClass"
                        (clicked)="editProjectClick()">Edit</dds-button>
                </div>
            </div>

            <div class="project-details-page__tab-container">
                <dds-tabs [theme]="tabContainerOptions.theme" [themeType]="tabContainerOptions.themeType"
                    [size]="tabContainerOptions.size" [isResponsive]="tabContainerOptions.isResponsive"
                    [customClass]="tabContainerOptions.customClass" [disabled]="tabContainerOptions.disabled"
                    [isInverse]="tabContainerOptions.isInverse" [ariaLabel]="tabContainerOptions.ariaLabel">

                    <dds-tab [label]="tabOptions1.label" [counter]="tabOptions1.counter" [icon]="tabOptions1.icon"
                        [disabled]="tabOptions1.disabled" [customClass]="tabOptions1.customClass"
                        (tabChanged)="tabChanged($event)" [isActive]="tabOptions1.isActive">
                    </dds-tab>

                    <dds-tab [label]="tabOptions2.label" [counter]="tabOptions2.counter" [icon]="tabOptions2.icon"
                        [disabled]="tabOptions2.disabled" [customClass]="tabOptions2.customClass"
                        (tabChanged)="tabChanged($event)" [isActive]="tabOptions2.isActive">
                    </dds-tab>

                    <dds-tab [label]="tabOptions3.label" [counter]="tabOptions3.counter" [icon]="tabOptions3.icon"
                        [disabled]="tabOptions3.disabled" [customClass]="tabOptions3.customClass"
                        (tabChanged)="tabChanged($event)" [isActive]="tabOptions3.isActive">
                    </dds-tab>

                </dds-tabs>

                <div class="tab-content">
                    <router-outlet />
                </div>

            </div>
        </section>

    </main>
</div>